<!--

-->
<template>
  <div>
    <div class="submit_claim_form">

      <!-- Subtitle -->
      <h2 class="subtitle">{{ $t(`${pagei18nKey}.title`) }}</h2>

      <h3 v-if="submitError" class="submit_claim_error">{{ $t(`${pagei18nKey}.submitClaimError`) }}</h3>

      <div class="submit_claim_additional_info_section">
        <label class="label">{{ $t(`${pagei18nKey}.additionalInfo`) }}</label>
        <textarea
          class="textarea"
          :name="additionalInfo"
          v-model="additionalInfo"
          :placeholder="$t(`${pagei18nKey}.additionalInfoPlaceholder`)" />
        <p
          v-show="errors.has('additionalInfo')"
          class="help is-danger">
          {{ errors.first('additionalInfo') }}
        </p>
      </div>

      <div class="submit_claim_whats_next_section" v-if="isKiosk">
        <!-- Subtitle -->
        <h2 class="subtitle">{{ $t(`${pagei18nKey}.whatsNextTitle`) }}</h2>
        <div class="">
        <MsHelpInfo
          :iconImageUrl="'/static/theme/img/exclamation-icon.svg'"
          :iconImageAlt="$t(`${pagei18nKey}.infoIconAlt`)"
          :imageUrl="'/static/theme/img/baggage-photos-illustration.svg'"
          :imageAlt="$t(`${pagei18nKey}.requiredBaggageIconAlt`)" >
            <span>{{ $t(`${pagei18nKey}.keepLuggageLabelPrefix`) }} <strong>{{ $t(`${pagei18nKey}.keepLuggageLabel`) }}</strong> {{ $t(`${pagei18nKey}.keepLuggageLabelSuffix`) }}</span>
          </MsHelpInfo>
          <span>{{ $t(`${pagei18nKey}.waitForConfirmationLabel`) }}</span>
        </div>
      </div>

      <div class="submit_claim_checkbox_field">
        <app-checkbox
          class="submit_claim_checkbox"
          :uncheckedSrc="'/static/theme/img/checkbox-unchecked.png'"
          :checkedSrc="'/static/theme/img/checkbox-checked.png'"
          :selected.sync="termsAgreed"
          @change="onTermsCheckboxChange" />
        <span>
          {{ $t(`${pagei18nKey}.termsCheckboxLabelPrefix`) }}
          <span
            class="submit_claim_terms_link"
            @click="openTerms">
            {{ $t(`${pagei18nKey}.termsCheckboxLabel`) }}
          </span>
        </span>
      </div>

      <div class="submit_claim_checkbox_field">
        <app-checkbox
          class="submit_claim_checkbox"
          :uncheckedSrc="'/static/theme/img/checkbox-unchecked.png'"
          :checkedSrc="'/static/theme/img/checkbox-checked.png'"
          :selected.sync="infoConfirmed"
          @change="onInfoConfirmationChange" />
        <span>
          {{ $t(`${pagei18nKey}.infoConfirmationCheckboxLabel`) }}
        </span>
      </div>

      <!-- Button -->
      <AppButton
        @click.native="onSubmitClaimClick"
        class="submit_claim_button"
        :state="buttonState"
        :type="buttonType"
        :text="$t(`${pagei18nKey}.submitClaimButton`)" />

      <div v-if="loading" class="submit_claim_spinner">
        <img :src="loadingSpinner"/>
      </div>
    </div>

    <!-- Terms & Conditons pop up -->
    <ms-app-message
      v-if="isTermsPopUpOpen"
      :title="termsAndConditions.termsAndConditionsTitle"
      :isOpen.sync="isTermsPopUpOpen">
      <ul>
        <li
          v-for="section in termsAndConditions.termsAndConditionsSections"
          v-html="section.content">
        </li>
      </ul>
      <span v-html="termsAndConditions.termsAndConditionsRefer"/>
    </ms-app-message>

  </div>
</template>
<script>
  import api from '@/api/api'
  import {ButtonStates, ButtonTypes} from '@/components/app-button'
  import MsAppMessage from '@/components/ms-app-message'
  import AppSettings from '@/app-settings.json'
  import MsHelpInfo from '@/components/ms-help-info'

  export default {
    name: 'SubmitClaimView',
    components: {
      MsAppMessage,
      MsHelpInfo
    },

    data: function () {
      return {
        termsAndConditions: {},
        pagei18nKey: 'message.submitClaim',
        buttonType: ButtonTypes.PRIMARY,
        isTermsPopUpOpen: false,
        loadingSpinner: AppSettings.submitInProgress,
        isKiosk: !!AppSettings.kioskSettings,
        loading: false,
        submitError: false
      }
    },
    mounted () {
      /**
       * Get terms and conditions data from api
       */
      api.getTermsAndConditions()
        .then(response => {
          this.termsAndConditions = response.data
        })
        .catch(console.error)
    },
    computed: {
      additionalInfo: {
        get () {
          return this.$store.getters.additionalInfo
        },

        set (value) {
          this.$store.commit('setAdditionalInfo', value)
        }
      },

      termsAgreed: {
        get () {
          return this.$store.getters.termsAgreed
        },
        set (value) {
          this.$store.commit('setTermsAgreed', value)
        }
      },

      infoConfirmed: {
        get () {
          return this.$store.getters.infoConfirmed
        },
        set (value) {
          this.$store.commit('setInfoConfirmed', value)
        }
      },

      buttonState: {
        get () {
          if (this.termsAgreed && this.infoConfirmed && !this.loading) {
            return ButtonStates.ENABLED
          }
          return ButtonStates.DISABLED
        }
      }
    },
    methods: {
      /**
       * Change value of terms agreed
       *
       * @param {boolean} value - Value to set terms agreed to
       */
      onTermsCheckboxChange: function (value) {
      },

      /**
       * Change value of info confirmation
       *
       * @param {boolean} value - Value to set info confirmation to
       */
      onInfoConfirmationChange: function (value) {
      },

      /**
       * Submit claim
       */
      onSubmitClaimClick: function () {
        // push isKiosk flag
        this.$store.commit('setIsKiosk', this.isKiosk)
        // push build id
        this.$store.commit('setBuildId', AppSettings.buildId)
        // console.log('Submit claim')
        this.loading = true
        let damageClaim = this.$store.getters.damageClaim
        // console.log(damageClaim)
        api.postClaim(damageClaim)
          .then(claimResult => {
            // console.log(claimResult)
            // console.log(claimResult.id)
            this.$store.commit('setSubmittedClaimId', claimResult.id)
            this.$router.push('/submit-success')
          })
          .catch(error => {
            this.loading = false
            this.submitError = true
            this.termsAgreed = false
            this.infoConfirmed = false

            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              // console.log(error.response.data)
              // console.log(error.response.status)
              // console.log(error.response.headers)
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              // console.log(error.request)
            } else {
              // Something happened in setting up the request that triggered an Error
              // console.log('Error', error.message)
            }
            // console.log(error.config)
          })
      },

      /**
       * Open terms & conditions pop up
       */
      openTerms: function () {
        this.isTermsPopUpOpen = true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/sass/main.scss";

  .submit_claim_form {
    @extend %app_form_container;
    position: relative;
  }

  .submit_claim_additional_info_section {
    padding-bottom: $dims-spacing-large;
    border-bottom: $default-border-style;
    margin-bottom: $dims-spacing-large;
  }

  .submit_claim_whats_next_section {
    padding-bottom: $dims-spacing-large;
    border-bottom: $default-border-style;
    margin-bottom: $dims-spacing-large;

    .subtitle {
      padding-bottom: 0;
    }
  }

  .submit_claim_terms_link {
    font-weight: $bold-font-weight;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    cursor: pointer;
  }

  .submit_claim_checkbox_field {
    display: flex;
    margin-bottom: $dims-padding-default;
  }

  .submit_claim_checkbox {
    margin-right: $dims-spacing-small;
  }

  .submit_claim_button {
    max-width: none;
    padding: $dims-spacing-small 0;
    margin: $dims-spacing-large auto 0;
  }

  .submit_claim_spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .submit_claim_error {
    text-align: center;
    color: $error-styling-color;
    font-weight: $semibold-font-weight;
    margin-bottom: $dims-padding-default;
  }

  ::v-deep .modal-card-body {

    li {
      margin-bottom: $dims-padding-default;
    }

  }

</style>
